<template>
  <div class="card-content">
    <div class="card-content-search">
      <el-button
        type="primary"
        v-if="!isAdmin && ([-1,4,5,7].indexOf(entStatusCopy) > -1) && pageStatusCopy=='edit'"
        size="small"
        v-debounce="[addData,'click',500]"
      >
        <i class="el-icon-plus"></i>新增
      </el-button>
    </div>
    <div class="card-content-table">
      <el-table
        border
        :data="tableList"
        align="center"
        style="width: 100%"
        ref="table"
        :header-cell-style="headerCellStyle"
        :row-class-name="tableRowClassName"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
          <template scope="scope">
            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="社保日期" width="200" align="center">
          <template scope="scope">
            <p>{{scope.row.startTime | dateStrIntercept}}至 {{scope.row.endTime | dateStrIntercept}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="materialName"
          align="center"
          :show-overflow-tooltip="true"
          label="材料名称"
        >
          <template scope="scope">
            <p>{{scope.row.materialName || "--"}}</p>
          </template>
        </el-table-column>
        <el-table-column label="社保附件" align="center" :show-overflow-tooltip="true">
          <template scope="scope">
            <p>{{ scope.row.pdfAttachment?'详见（'+scope.row.pdfAttachment.title+"）":'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="数据来源"
          align="center"
          :show-overflow-tooltip="true"
          width="100"
          prop="dataSource"
        ></el-table-column>
        <el-table-column label="数据状态" align="center" width="120" prop="state">
          <template scope="scope">
            <p type="text" class="change-examine">
              <i :class="formatDataState(scope.row.dataState,'class')"></i>
              <span>{{scope.row.dataStateName}}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="登记日期"
          width="90"
          align="center"
          :show-overflow-tooltip="true"
          prop="createTime"
        >
          <template scope="scope">
            <p>{{scope.row.createTime?formatDate(scope.row.createTime,"yyyy-MM-dd"):'--'}}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="作废日期"
          align="center"
          width="90"
          :show-overflow-tooltip="true"
          prop="cancelTime"
        >
          <template scope="scope">
            <p>{{scope.row.cancelTime?formatDate(scope.row.cancelTime,"yyyy-MM-dd"):'--'}}</p>
          </template>
        </el-table-column> -->
       
   
      </el-table>
    
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getUUID } from "@/utils/index";
// import securityInfoForm from "./securityInfoForm"
export default {
  components: {
    // securityInfoForm
  },
  props: {
    entStatus: {
      type: Number,
      default: 99
    },
    pageStatus: {
      type: String,
      default: ""
    },
    socialSecurityList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    entStatus: {
      immediate: true,
      handler(val) {
        this.entStatusCopy = val;
      },
      deep: true
    },
    pageStatus: {
      immediate: true,
      handler(val) {
        this.pageStatusCopy = val;
      },
      deep: true
    },
    socialSecurityList: {
      immediate: true,
      handler(val) {
        this.tableList = val;
        this.total = this.tableList.length;
      },
      deep: true
    }
  },
  data() {
    return {
      entStatusCopy: "",
      pageStatusCopy: "",
      expands: [], // 要展开的行，数值的元素是row的key值
      keyWord: "",
      tableList: [],
      headerCellStyle: {
        "background-color": "#EFF3F6",
        "font-size": "14px",
        color: "#000000"
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  filters: {
    dateStrIntercept(str) {
      if (str && str.length > 0) {
        return str.substring(0, 10);
      } else {
        return "--";
      }
    }
  },
  computed: {
    ...mapState({
      orgId: state => state.user.orgId,
      entId: state => state.user.userinfo.userId,
      isAdmin: state => state.user.userPermStr == "admin"
    }),
    editFlag: {
      get() {
        return this.pageStatusCopy == "edit";
      }
    }
  },
  created() {
    // this.queryData();
    this.$store.dispatch("attFilesDictionary/getEntSocialSecurityAtt"); //获取社保附件配置
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.oprType) {
        return row.oprType === "4"
          ? "warning-row"
          : row.oprType === "1"
          ? "success-row"
          : "";
      } else {
        return "";
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    // 表单保存成功
    formSaveSuccess(id) {
      if (id) {
        // this.queryData();
      }
    },
    // 表单保存取消
    formCancel(id) {
      if (id.toString().indexOf("-") > -1) {
        this.deleteData(id);
      } else {
        var index = this.tableList.findIndex(val => val.id == id);
        this.$refs.table.toggleRowExpansion(this.tableList[index], false);
      }
    },
    copyOrChange(row) {
      let copyOrChangeDataUrl = "/change/hentQualificationCert/modifyCopy";
      this.loadingFlag = true;
      this.$httpReq.get(copyOrChangeDataUrl + "?id=" + row.id).then(res => {
        if (res.data.code != "1") {
          this.$message({
            message: res.data.msg,
            type: "error"
          });
          return;
        }
        // this.queryData(res.data.data.id || "");
        this.$message({
          message: res.data.msg,
          type: "success"
        });
      });
    },
    // 获取数据
    // queryData(toogleRowId) {
    //   let listUrl = this.$route.params.changeId
    //     ? "/change/hentSocialSecurity/list"
    //     : "/entSocialSecurity/list";
    //   this.$httpReq
    //     .post(listUrl, {
    //       page: this.currentPage,
    //       rows: this.pageSize,
    //       filter: {
    //         entId:
    //           this.$route.params.changeId || this.$route.params.id || this.orgId
    //       },
    //       searchKey: "",
    //       orderBy: "create_time desc"
    //     })
    //     .then(res => {
    //       if (res.data) {
    //         this.tableList = res.data.rows;
    //         this.total = res.data.total;
    //         if (toogleRowId) {
    //           var index = this.tableList.findIndex(
    //             val => val.id == toogleRowId
    //           );
    //           this.toogleExpandTrue(this.tableList[index]);
    //         } else {
    //           this.expands = [];
    //         }
    //       }
    //     });
    // },
    // 新增
    addData() {
      let hasUnSaveData = false;
      this.tableList.forEach(item => {
        if (item.id.toString().indexOf("-") > -1) {
          hasUnSaveData = true;
        }
      });
      if (hasUnSaveData) {
        this.$message({
          message: "列表里有未保存的数据项，请先保存再新增！",
          type: "error"
        });
        return;
      }

      if (this.entStatus == 0 || this.entStatus == 6) {
        this.$message({
          message:
            "请先点击【发起变更】按钮，或将上次变更的内容提交通过后再【新增】！",
          type: "error"
        });
      } else {
        let data = {
          id: getUUID(),
          dataState: 4
        };
        if (this.tableList.length == this.pageSize) this.tableList.pop();
        this.tableList.unshift(data);
        this.expands.push(this.tableList[0].id);
      }
    },
    // 删除/取消
    deleteData(id) {
      debugger;
      if (id.toString().indexOf("-") > 0) {
        var index = this.tableList.findIndex(val => val.id == id);
        if (index > -1) this.tableList.splice(index, 1);
      } else {
        let deleteUrl = this.$route.params.changeId
          ? "/change/hentSocialSecurity/delete"
          : "/entSocialSecurity/delete";
        this.$httpReq
          .post(deleteUrl, {
            id: id
          })
          .then(res => {
            if (res.data.code == 1) {
              // this.queryData();
              this.$message({
                message: res.data.msg,
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning"
              });
            }
          });
      }
    },
    // 查看
    toogleExpandTrue(row) {
      this.$refs.table.toggleRowExpansion(row, true);
    },
    // 收起
    toogleExpandFalse(row) {
      this.$refs.table.toggleRowExpansion(row, false);
    },
    // 作废
    voidData(row) {
      this.$confirm(`确定要作废该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let voidUrl = this.$route.params.changeId
          ? "/change/hentSocialSecurity/cancel"
          : "/entSocialSecurity/cancel";
        this.$httpReq.get(voidUrl + "?id=" + row.id).then(res => {
          if (res.data.code == 1) {
            // this.queryData();
            this.$message({
              message: res.data.msg,
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.queryData();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-content {
  padding: 10px 0px;
  .card-content-search {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 4px;
    margin-right: 12px;
  }

  .card-content-table {
    margin: 16px 12px 0 12px;
    /deep/ .el-input__inner {
      width: 100%;
    }
  }
}
</style>